import { FormHelperText } from "@mui/material";
import getMessage from "../../../utils/getMessage";
import { string } from "yup";
import RequiredAsterisk from "../../../components/forms/RequiredAsterisk";
import { EMOJI_CATEGORIES, getEmojiList } from "../../../data/emoji";
import DigiraatiRadioInput from "../../../components/forms/DigiraatiRadioInput";

export const DigiraatiAvatarInputValidationSchema = {
  avatar: string()
  .required('required')
  .oneOf(getEmojiList(EMOJI_CATEGORIES.find(ec => ec.id=='emojiAnimals'), null), 'avatarList')
}

/** For use as a Formik Field component */
const DigiraatiAvatarInput = ({
  field,
  form,
  labelKey='avatar',
}) => {
  const {touched, errors} = form;
  
  const animals = EMOJI_CATEGORIES.find(ec => ec.id=='emojiAnimals');
  const avatars = getEmojiList(animals, null)

  return ( 
    <div className="hds-text-input">
      <fieldset style={{width: '100%'}}>
        <legend>
          {getMessage(labelKey)}<RequiredAsterisk />
        </legend>
      <div className="digiraati-avatar-input">
      { avatars.map( (avatar) =>
          <DigiraatiRadioInput 
            key={`avatar${avatar}`} 
            name="avatar" 
            form={form}
            field={field} 
            value={avatar}

          >
            <span className="user-avatar user-avatar--large">
              {avatar}
            </span>
          </DigiraatiRadioInput>
      ) }

      </div>
      <FormHelperText
        id="avatar_input_helpertext"
        error={Boolean(touched.avatar && errors.avatar)}
        sx={{font: 'normal normal normal 18px PT Sans'}}
      >
        {touched.avatar && errors.avatar
          ? getMessage(errors.avatar)
          : ' '}
      </FormHelperText>
      </fieldset>
    </div>
  )
}

export default DigiraatiAvatarInput;